"use client";
import React, { useState } from "react";
import Image from "next/image";
import PdfImg1 from "@/assets/pdf-img/pdf-img-1.png"
import PdfImg2 from "@/assets/pdf-img/pdf-img-2.png"
import Link from "next/link";


const data = {
    "2024-25": [
        {
            img: PdfImg1,
            text: "Please review the information provided here for a complete and detailed overview of the course fees, along with all relevant inclusions",
            link: "https://cdn.msu.edu.in/pdf/MSU-Fees-Structure-25-26-December-Final-Copy.pdf",
        },
        {
            img: PdfImg2,
            text: "Refunds will be processed in accordance with the 2025-2026 UGC policy. The document will be updated as soon as the UGC releases the updated guidelines.",
            link: "https://cdn.msu.edu.in/website-images/fee-refund-policy-2024-25.pdf",
        },
    ],

};

const FeeStructureAndRefundPolicy = () => {
    const [activeTab, setActiveTab] = useState("2024-25");
    const tabs = ["2024-25"];


    return (
        <section className="w-full flex justify-center">
            <div className="max-w-[var(--max-page-width)] w-full px-[var(--container-padding)] my-4 sm:my-8 md:my-14 lg:my-20">

                <h1 className="font-extrabold text-[clamp(20px,3vw,42px)] text-black leading-normal mb-2">
                    Official Fee Refund Policy
                </h1>

                <p className="text-base md:text-lg mb-6">
                    Understand the rules, conditions, and process for requesting a fee refund at MSU.
                </p>

                <div className="flex gap-3 mt-4 mb-4 md:mb-8">
                    {tabs.map((year) => (
                        <button
                            key={year}
                            onClick={() => setActiveTab(year)}
                            className={`px-5 py-2 border text-sm font-semibold transition-all duration-200 cursor-pointer
                        ${activeTab === year
                                    ? "bg-[#FFA201] border-[#FFC72C] text-black shadow-sm hover:bg-[#ffb733]"
                                    : "bg-white border-gray-300 text-black hover:bg-[#FFF4DB] hover:border-[#FFA201]"
                                } hover:-translate-y-0.5`
                            }
                        >
                            {year}
                        </button>
                    ))}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {data[activeTab].map((item, index) => (
                        <div key={index}
                            className="border border-[rgba(0,0,0,0.15)] group overflow-hidden shadow-sm bg-white transition-transform duration-300 hover:shadow-lg"
                        >
                            <div className="w-full aspect-[4/3] relative overflow-hidden">
                                <Image
                                    src={item.img}
                                    alt="Fee Policy"
                                    fill
                                    className="object-cover transition-transform duration-500 ease-out group-hover:scale-105"
                                />
                            </div>

                            <div className="p-5">
                                <p className="text-sm md:text-base text-black mb-4">
                                    {item.text}
                                </p>

                                <Link
                                    href={item.link}
                                    target="_blank"
                                    className="
                                        mt-auto inline-flex items-center justify-center
                                        px-5 py-2 text-base font-semibold
                                        border border-[#081E2D] bg-[#081E2D] text-white
                                        transition-colors duration-300
                                        group-hover:bg-white group-hover:text-[#081E2D]"
                                >
                                    View PDF
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default FeeStructureAndRefundPolicy;
